import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';
import { Issue } from '../types';

const FIELDS = [
  'dagrun_pm_issueid','dagrun_pm_name','dagrun_pm_description','dagrun_pm_severity',
  'dagrun_pm_status','dagrun_pm_ownerid','dagrun_pm_resolutionnotes',
  'dagrun_pm_clientvisible','dagrun_pm_resolvedon','createdon','_dagrun_pm_projectid_value',
];

export async function getProjectIssues(pca: IPublicClientApplication, projectId: string): Promise<Issue[]> {
  return dvList<Issue>(pca, 'dagrun_pm_issues', {
    select: FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    orderby: 'createdon desc',
  });
}

export async function createIssue(pca: IPublicClientApplication, projectId: string, name: string): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_issues', {
    dagrun_pm_name: name,
    dagrun_pm_severity: 100000001, // Medium
    dagrun_pm_status: 100000000,   // New
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  });
}

export async function updateIssue(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_issues', id, patch);
}

export async function deleteIssue(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_issues', id);
}

export async function createIssueWithFields(
  pca: IPublicClientApplication,
  projectId: string,
  fields: { name: string; description?: string | null; severity?: number; ownerid?: string | null; clientvisible?: boolean },
): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: fields.name,
    dagrun_pm_severity: fields.severity ?? 100000001,
    dagrun_pm_status: 100000000, // New
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  };
  if (fields.description) body.dagrun_pm_description = fields.description;
  if (fields.ownerid)     body.dagrun_pm_ownerid = fields.ownerid;
  if (fields.clientvisible != null) body.dagrun_pm_clientvisible = fields.clientvisible;
  return dvCreate(pca, 'dagrun_pm_issues', body);
}
